<template>
  <div class="color-picker">

      <div class="color" v-for="color in colors" v-bind:key="color.name">
          <label class="disk">
              <img :src="'/storage/'+color.image" >
              <input type="radio" :name="reference" :value="color.name" v-model="colorInput">
              <span class="checkmark"></span>
          </label>
          <div class="mt-2">{{color.name}}</div>
      </div>
  </div>
</template>

<script>
import axios from "axios"

export default {
  name: "color-picker",
  data() {
    return {
      colorsOld: [
        {
          name: "Passoni black",
          code: "#000",
        },
        {
          name: "Passoni white",
          code: "#fff",
        },
        {
          name: "Passoni grey",
          code: "#444",
        },
        {
          name: "Passoni yellow",
          code: "yellow",
        },
        {
          name: "Passoni blue",
          code: "blue",
        },
        {
          name: "Giro pink",
          code: "pink",
        },
        {
          name: "Acid green",
          code: "green",
        },
        {
          name: "Green fluo",
          code: "lightgreen",
        },
        {
          name: "Sprint red",
          code: "red",
        },
      ],
    };
  },
  props: ['results', 'reference', 'colors'],
  computed: {
      colorInput: {
          get: function() {
            return this.results.colour[this.reference];
          },
          set: function(e) {
              this.$emit('set-color-event', e);
          },
      }
  }
};
</script>

<style lang="scss" scoped>

.color-picker {
    .color {
        display: inline-block;
        text-transform: uppercase;
        font-size: 8px;
        font-weight: bold;
        max-width: 50px;
        margin-right: 20px;
        margin-bottom: 10px;
        text-align: center;
        letter-spacing: 1.25px;
        .disk {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            line-height: 40px;
            border: none;
            position: relative;
            img {
              width: 100%;
            }
            input {
              position: absolute;
              opacity: 0;
              cursor: pointer;
              height: 0;
              width: 0;
              top: 17px;
              left: 11px;
              &:checked ~ .checkmark {
                background-color: #000000;
                &:after {
                  display: block;
                }
              }
            }
            .checkmark {
              position: absolute;
              top: 16px;
              left: 10px;
              height: 15px;
              width: 15px;
              background-color: #ffffff;
              border-radius: 50%;
              cursor: pointer;
              &:after {
                content: "";
                position: absolute;
                display: none;
              }
            }
        }
    }
}

</style>